export default "__VITE_ASSET__COPhUN_k__"